/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Campaign/Broadcasting/Enums/WhatsAppAiAgentEvent.php */
export const whatsAppAiAgentEvent = {
	ActivityChanged: 'activity-changed',
} as const

/** @see backend/nexus/modules/Campaign/Broadcasting/Enums/WhatsAppAiAgentEvent.php */
export type WhatsAppAiAgentEvent = (typeof whatsAppAiAgentEvent)[keyof typeof whatsAppAiAgentEvent]
